/**
 * @fileoverview
 * Helper to determine `presentation` base on app context (and params)
 * for tracking payload.
 */

import { isStories } from '@core/params/helpers/isStories'
import {
  type EmbedFeedParams,
  type IAnyWidgetParams,
  IPresentation,
} from '@core/types'
import { ThumbnailShapeEnum } from '@core/types'
import { AppContextType } from '@embed/components/helpers'

/**
 *
 */
export const getPresentationFromParams = (
  appContextType: AppContextType,
  params: IAnyWidgetParams,
): IPresentation => {
  if (params.widget_presentation === IPresentation.STORYBLOCK_PRODUCT_GALLERY) {
    return IPresentation.STORYBLOCK_PRODUCT_GALLERY
  }

  switch (appContextType) {
    case AppContextType.EMBED_ADD_TO_CALENDAR_CONTEXT_TYPE:
      return IPresentation.ADD_TO_CALENDAR
    case AppContextType.EMBED_SHARE_CONTEXT_TYPE:
      return IPresentation.SHARE
    case AppContextType.EMBED_HERO_CONTEXT_TYPE:
      return IPresentation.HERO
    case AppContextType.EMBED_PLAYER_TYPE:
      return IPresentation.PLAYER
    case AppContextType.EMBED_STORYBLOCK_CONTEXT_TYPE:
      return IPresentation.STORYBLOCK
    case AppContextType.EMBED_STORYLINK_CONTEXT_TYPE:
      return IPresentation.STORYLINK
    case AppContextType.EMBED_CONTEXT_TYPE:
    case AppContextType.EMBED_GRID_CONTEXT_TYPE: {
      if ((params as EmbedFeedParams).thumbnail_style === 'dynamic') {
        return IPresentation.DYNAMIC_CAROUSEL
      }

      if ((params as EmbedFeedParams).thumbnail_orientation === 'horizontal') {
        return IPresentation.HORIZONTAL_CAROUSEL
      }

      if ((params as EmbedFeedParams).player_deck_layout) {
        return IPresentation.PLAYER_DECK
      }

      if (isStories(params as EmbedFeedParams)) {
        if (
          (params as EmbedFeedParams).thumbnail_shape ===
          ThumbnailShapeEnum.RECTANGLE
        ) {
          return IPresentation.VERTICAL_STORIES
        }

        return IPresentation.CIRCLE_STORIES
      }

      switch (params.mode) {
        case 'grid':
          return IPresentation.GRID
        default:
          return IPresentation.CAROUSEL
      }
    }
    case AppContextType.HEADLESS_FEED:
      return IPresentation.CAROUSEL
    default:
      throw new Error('Unknown appContexType')
  }
}
